import CardEvento from './CardEvento'

export default CardEvento